import { render, staticRenderFns } from "./MarketDataMap.vue?vue&type=template&id=2546a91e&lang=pug"
import script from "./MarketDataMap.vue?vue&type=script&lang=js"
export * from "./MarketDataMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports